import React from 'react';

import { Inner, Text, Wrapper } from './DepGroupHeader.style';

export interface DepPrivateBadgeProps {
    text?: string;
    bgColor?: string;
}

export function DepPrivateBadge({ text = 'Private Pod', bgColor }: DepPrivateBadgeProps) {
    return (
        <Wrapper>
            <Inner $bgColor={bgColor}>
                <Text>{text}</Text>
            </Inner>
        </Wrapper>
    );
}
